module.exports = __webpack_public_path__ + "img/pro_night_6.4ef0ce47.jpg";